exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._vXMpRcsJ6hyFJI4obKnz{display:flex;min-height:100vh;flex-direction:column}._3_PzKKl_dgtuAY1LDP-WsE{flex:1 0 auto}._34AbOpZaA4UnxTtPcI4Wg7{background:#f5f5f5}\n", ""]);

// Exports
exports.locals = {
	"StandardLayout": "_vXMpRcsJ6hyFJI4obKnz",
	"content": "_3_PzKKl_dgtuAY1LDP-WsE",
	"greyBg": "_34AbOpZaA4UnxTtPcI4Wg7"
};